
import React from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
const CorrectiveActionReportModal = ({ show, handleClose }) => {
    return (
        <Modal show={show} onHide={handleClose} centered size="lg" className="font_family">
            <Modal.Body className="p-5">
                <h4 className="fw-bold mb-4">Corrective Action Report</h4>

                {/* Corrective Action Info */}
                <div className="p-3 border rounded bg-light mb-4">
                    <h6 className="fw-semibold mb-3">Corrective Action Information</h6>
                    <Row>
                        <Col md={6}><strong>Product Name:</strong> MEP</Col>
                        <Col md={6}><strong>NC ID:</strong> <span className="text-dark">Ru_90_46</span></Col>
                    </Row>
                    <Row>
                        <Col md={6}><strong>Qty NC:</strong> 50pcs</Col>
                        <Col md={6}><strong>Report Date:</strong> <span className="text-dark">12/03/2025</span></Col>
                    </Row>
                    <Row className="mt-2">
                        <Col md={6}><strong>Corrective Action Type:</strong> Cleaning of Mold</Col>
                        <Col md={6}><strong>NC Type:</strong> <span className="text-dark">Blowhole</span></Col>
                    </Row>
                    <div className="mt-3">
                        <Button variant="outline-secondary" size="sm">Review NC Report</Button>
                    </div>
                </div>
                <div className="p-3 border rounded bg-light mb-4">
                    <h6 className="fw-semibold mb-3">Corrective Action Test By Supervisor</h6>

                    <h6 className="mb-2">Inspection Checklist</h6>
                    <Form.Check label="Visual Inspection (No visible defects)" defaultChecked />
                    <Form.Check label="Dimensional Check (Meets specifications)" defaultChecked />
                    <Form.Check label="Quantity Check (Matches delivery note)" defaultChecked />
                    <Form.Check label="Packaging Condition (No damage)" defaultChecked />
                    <Form.Check label="Material Certificate (Provided and valid)" defaultChecked />
                    <Row className="mt-3">
                        <Col md={4} className="d-flex align-items-center">
                            <strong>Producted Inspected</strong>
                        </Col>
                        <Col md={4}>
                            <Form.Control type="number" defaultValue="50" />
                        </Col>
                        <Col md={4} className="d-flex align-items-center">pcs</Col>
                    </Row>
                    <Row className="mt-3">
                        <Col md={4} className="d-flex align-items-center">
                            <strong>Producted Passed</strong>
                        </Col>
                        <Col md={4}>
                            <Form.Control type="number" defaultValue="50" />
                        </Col>
                        <Col md={4} className="d-flex align-items-center">pcs</Col>
                    </Row>
                    <Row className="mt-4">
                        <Col md={4}><strong>Effectiveness of Corrective Action</strong></Col>
                        <Col md={8}>
                            <Form.Select defaultValue="">
                                <option value="">Select Effectiveness</option>
                                <option>Effective</option>
                                <option>Partially Effective</option>
                                <option>Ineffective</option>
                            </Form.Select>
                        </Col>
                    </Row>
                </div>
                <Form.Group>
                    <Row>
                        <Col md={3}>
                            <Form.Label><strong>Notes</strong></Form.Label></Col>
                        <Col md={9}>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                defaultValue="Lorem ipsum dolor sit amet consectetur. Et integer metus pretium cras. Duis urna curabitur integer commodo. Sit gravida ultrices cursus egestas. Nibh consectetur blandit dui enim sagittis. Iaculis."
                            />
                        </Col>
                    </Row>
                </Form.Group>
            </Modal.Body>
            <Modal.Footer className="border-0">
                <Button variant="secondary" onClick={handleClose}>Cancel</Button>
                <Button variant="dark">Submit</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CorrectiveActionReportModal;
